import * as React from "react"
import { Container, Row, Col } from "react-bootstrap"
import PlayVideo from "../../Play/custom-video";
import gql from "graphql-tag"
import { useQuery } from '@apollo/client';
import moment from 'moment'
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import Slider from "react-slick";
import { SlickNextIcon,SlickPrevIcon } from "../../Icons/Icons";
import "./LatestNews.scss"
import { Link } from "@StarberryUtils";
import ImageModule from "../../common/Image_Module";
import { LATEST_NEWS_PAGE_URL } from "../../common/site/constants";

const GET_ALL_NEWS = gql`
  query GetNews{	
    newsItems(sort:"Date:desc", limit:6)  {
        id
        Content
        Title
        Date
        Embed_Video_URL
        Featured
        Meta_Description
        Meta_Title
        ggfx_results {
            id
            src_cftle
            src_url
            transforms
            updatedAt
            createdAt
            _id
    }
        URL
        Tile_Image {
          alternativeText
          url
        }
        news_category {
          Name
          URL
        }
        imagetransforms
      }
  }
`;


const LastestNews = (props) => {
    let [isPlay, setPlay] = React.useState(false);

    const NextArrow = ({ onClick }) => {
        return (
          <button className="slick-next" onClick={onClick}>
            <SlickNextIcon />
          </button>
        );
      };
      
      const PrevArrow = ({ onClick }) => {
        return (
          <button className="slick-prev" onClick={onClick}>
            <SlickPrevIcon />
          </button>
        );
      };
    
      const settings = {
        dots: false,
        lazyLoad: true,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 2,
        infinite: true,
        arrows: true, 
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        mobileFirst: true,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: true, 
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              dots: true, 
            },
          },
        ],
      };
    const { loading, error, data } = useQuery(GET_ALL_NEWS);

    if (loading) return <p>Loading ...</p>;
    const newsList = data?.newsItems; 
    return (
        <div className="latest-news-section sec-pdy-120">
            {newsList && newsList.length > 0 &&
                <Container className="featured-properties">
                    <h4>Latest News & Insights</h4>
                    <p className="text-sm">Dive into the latest updates and insightful analysis of Dubai's real estate market, crafted by our seasoned team of real estate agents in Dubai. Empower yourself with the knowledge and expertise needed to make informed decisions in your property journey.</p>
                    <Slider  {...settings}>
                        {newsList.map((news, index, active) => {

                          const image_url = news.Tile_Image?.url 

                          let processedImages = JSON.stringify({});
                          if (news?.imagetransforms?.Tile_Image_Transforms) {
                              processedImages = news.imagetransforms.Tile_Image_Transforms;
                          }
                          const blogUrl = news.news_category?.URL 
                          ? `${LATEST_NEWS_PAGE_URL.alias}/${news.news_category?.URL}/${news?.URL}` 
                          : `${LATEST_NEWS_PAGE_URL.alias}/${news?.URL}`;     

                            return (
                                <div className="all-products news-list">
                                    <div className="properties-wrapper img-zoom">
                                        <Link to={blogUrl}>
                                            {/* <ImageTransform 
                                            imagesources={image_url} 
                                            renderer="srcSet" 
                                            imagename="news-items.Tile_Image.tile_2" 
                                            attr={{ alt: news.Title+ ' - Dacha', class:'' }} 
                                            imagetransformresult={processedImages} 
                                            id={news.id}/> */}
                                            <ImageModule 
                                                ImageSrc={news?.Tile_Image } 
                                                attr={{ alt: news.Title + ' - Dacha', class: '' }} 
                                                ggfx_results={news?.ggfx_results} 
                                                imagename="news-items.Tile_Image.tile_2" 
                                                strapi_id={news?.id} 
                                        /> 
                                        </Link>
                                        {news.Embed_Video_URL &&
                                            <div className="banner-btn">
                                                <PlayVideo url={news.Embed_Video_URL}  
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className="newsletter-info">
                                        {news.Date &&
                                        <div className="time-info text-xxs">
                                            <span><i className="icon-clock"></i></span>
                                            <span>{moment(news.Date).format("DD/MM/YYYY")}</span>
                                        </div>
                                        }
                                        <h6 className="text-md-bold">
                                            <Link to={blogUrl}>
                                                {news.Title} 
                                            </Link>
                                        </h6>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </Container>
            }
            {/* <PlayVideo
                isOpen={isPlay}
                isCloseFunction={setPlay}
                videoId="V8ksSGxo6no"
                isAutoPlay={1}
            /> */}
        </div>
    )
}
export default LastestNews